import React from "react";
import styled from "styled-components";
import LanguageComponent from "../LangTranslation/LanguageComponent";
import basketIcon from "../../Images/basketicon.svg";
import VTEXIcon from "../../Images/VTEX-logo.png";
import { useSession } from "../../authentications/SessionContext";

const StyledImage = styled.img`
  max-width: 110px; /* Default size for laptop screens */
  width: 100%;
  height: auto; /* Maintain aspect ratio */
  object-fit: contain;

  // @media (max-width: 768px) {
  //   max-width: 150px; /* Adjust for smaller screens */
  // }

  // @media (max-width: 480px) {
  //   max-width: 120px; /* Further adjust for extra small screens */
  // }
`;

function AuthTopbar({ className = "" }) {
  const { sessionInfo } = useSession();
  const { isVTEX } = sessionInfo;
  return (
    <div
      className={`d-flex justify-content-between align-items-center ${className}`}
    >
      <StyledImage
        className="image"
        // height="100%"
        // width="100%"
        // style={{ maxWidth: 200, objectFit: "contain" }}
        src={isVTEX ? VTEXIcon : basketIcon}
        alt="logo"
      />
      <LanguageComponent />
    </div>
  );
}

export default AuthTopbar;
